import React, {Component} from 'react';
import ReactDOM from 'react-dom';
import {connect} from 'react-redux';
import LANGUAGES_CONTROLLER from '../../../controllers/languages';
import Logger, {LOG_LEVELS} from '../../../utils/logger';

const log = new Logger('EC_LISTING_VAT_PREVIEW', LOG_LEVELS.DEBUG);

class VATPreview extends Component {

    constructor(props) {
        super(props);
        this.state = Object.assign({}, this.state, { isVatNumberReadOnly: true});
    }

    vatNumberButtonClick(){
        this.setState({isVatNumberReadOnly: !this.state.isVatNumberReadOnly});
        if(this.state.isVatNumberReadOnly) {
            ReactDOM.findDOMNode(this.refs.vatNumber).focus();
        }
    }

    UNSAFE_componentWillMount() {
        this.props.onInit();
    }

    render() {
        log.debug('render(): ', this.props);
        const companyId =  parseInt(this.props.companyId, 10); //parseInt("138916", 10)
        const vatNumber = this.props.vatNumber;//"BE132465798"
        const companyList = this.props.companyList;
        log.debug('render(): companyId: ', companyId);
        log.debug('render(): companyList: ', companyList);
        const matchedCompanies = companyList.filter(company => companyId === company.id);
        log.debug('render(): matchedCompanies: ', matchedCompanies);
        const company = (matchedCompanies && matchedCompanies.length > 0 && matchedCompanies[0]) || {};
        log.debug('render(): company: ', company);
        const vatNumbers = (company && company.vatNumbers) || [];
        const matchedVatNumbers = vatNumbers.filter(vatDetails => vatDetails.vatnumber === vatNumber);
        const vatDetails = (matchedVatNumbers && matchedVatNumbers.length > 0 && matchedVatNumbers[0]) || {};
        const vatNumberTypeLS = (vatDetails.vatnumberType && this.props.vatNumberTypes[vatDetails.vatnumberType.toString()]) || '';
        const vatNumberType = vatNumberTypeLS === '' ? '' : LANGUAGES_CONTROLLER.format(this.props.languages, vatNumberTypeLS.languageString);

        const vatReturnFreqLS = (vatDetails.vatReturnFrequency && this.props.vatNumberTypes[vatDetails.vatReturnFrequency.toString()]) || '';
        const vatReturnFreq = vatReturnFreqLS === '' ? '' : LANGUAGES_CONTROLLER.format(this.props.languages, vatReturnFreqLS.languageString);
        
        log.debug('render(): ', company);

        return(
            <div>
                <div>
                    <label htmlFor="vatNumber">{LANGUAGES_CONTROLLER.format(this.props.languages, 'vatPreview_VATNumber')}</label>
                    <s-row>
                        <s-col span="9">
                            <div className="flex-box">
                                <input type="text" id="vatNumber" style={{minWidth: 'auto', width: '100%'}} ref="vatNumber" value={vatNumber} readOnly={this.state.isVatNumberReadOnly}/>
                            </div>  
                        </s-col>
                        <s-col span="3">
                            <div className="flex-box">
                                <button onClick={this.vatNumberButtonClick.bind(this)}>
                                    {
                                        this.state.isVatNumberReadOnly 
                                            ? LANGUAGES_CONTROLLER.format(this.props.languages, 'vatPreview_VATNumberEdit')  
                                            : LANGUAGES_CONTROLLER.format(this.props.languages, 'vatPreview_VATNumberSave')
                                    } </button>
                            </div>  
                        </s-col>
                    </s-row>
                </div>
                <div>
                    <label htmlFor="company">{LANGUAGES_CONTROLLER.format(this.props.languages, 'vatPreview_Company')}</label>
                    <s-row>
                        <s-col span="12">
                            <input type="text" id="company" value={company.name || this.props.companyId} style={{minWidth: 'auto', width: '100%'}} readOnly/>  
                        </s-col>
                    </s-row>
                </div>
                <div>
                    <label htmlFor="country" > {LANGUAGES_CONTROLLER.format(this.props.languages, 'vatPreview_Country')}</label>
                    <s-row>
                        <s-col span="12">
                            <input type="text"  id="country" value={vatDetails.vatnumberCountry} style={{minWidth: 'auto', width: '100%'}} readOnly/>
                        </s-col>  
                    </s-row>
                </div>
                <div>
                    <label htmlFor="vatNumberType" >{LANGUAGES_CONTROLLER.format(this.props.languages, 'vatPreview_VATNumberType')}</label>
                    <s-row>
                        <s-col span="12">
                            <input type="text" id="vatNumberType" value={vatNumberType} style={{minWidth: 'auto', width: '100%'}} readOnly/>
                        </s-col>
                    </s-row>
                </div>
                <div>
                    <label htmlFor="vatReturnFrequency">{LANGUAGES_CONTROLLER.format(this.props.languages, 'vatPreview_VATReturnFrequency')}</label>
                    <s-row>
                        <s-col span="12">
                            <input type="text"  id="vatReturnFrequency" value={vatReturnFreq} style={{minWidth: 'auto', width: '100%'}} readOnly/>
                        </s-col>    
                    </s-row>
                </div>
                <div>
                    <label htmlFor="addressRepresentative">{LANGUAGES_CONTROLLER.format(this.props.languages, 'vatPreview_NameRepresentative')}</label>
                    <s-row>
                        <s-col span="12">
                            <input type="text" id="addressRepresentative" value={vatDetails.represAddress} style={{minWidth: 'auto', width: '100%'}} readOnly/>
                        </s-col>  
                    </s-row>
                </div>
                <div>
                    <label htmlFor="zipRepresentative">{LANGUAGES_CONTROLLER.format(this.props.languages, 'vatPreview_AddressRepresentative')}</label>
                    <s-row>
                        <s-col span="12">
                            <input type="text" id="zipRepresentative" value={vatDetails.represZip} style={{minWidth: 'auto', width: '100%'}} readOnly/>
                        </s-col>  
                    </s-row>
                </div>
                <div>
                    <label htmlFor="nameRepresentative">{LANGUAGES_CONTROLLER.format(this.props.languages, 'vatPreview_ZIPRepresentative')}</label>
                    <s-row>
                        <s-col span="12">
                            <input type="text" id="inputPassword" value={vatDetails.represName} style={{minWidth: 'auto', width: '100%'}} readOnly/>
                        </s-col>  
                    </s-row>
                </div>
                <div>
                    <label htmlFor="cityRepresentative">{LANGUAGES_CONTROLLER.format(this.props.languages, 'vatPreview_CityRepresentative')}</label>
                    <s-row>
                        <s-col span="12">
                            <input type="text" id="cityRepresentative" value={vatDetails.represCity} style={{minWidth: 'auto', width: '100%'}} readOnly/>
                        </s-col>  
                    </s-row>
                </div>
            </div>
        );
    }
}

function mapStateToProps(state) {
    let props = {
        languages: state.languages,
        vatNumberTypes: (state.content && state.content.data && state.content.data.vatNumberTypes) || {},
        vatReturnFrequencies: (state.content && state.content.data && state.content.data.vatReturnFrequencies) || {},
        companyList: (state.companies && state.companies.data ) || []
    };
    return props;
}


function mapDispatchToProps(dispatch) {
    return {

        onInit: () => {
            log.debug('onPageLoad: ');
        },
        
        //Post Updated VAT Number
        onSave: (params) => {
            log.debug('onSave(): ', params);
            if(params && params.vatNumber) {
                log.debug('Updating VAT Number: ', params.vatNumber);
            } else {
                log.debug('Nothing to update.');
            }
        }
    };
}


export default connect(mapStateToProps, mapDispatchToProps)(VATPreview);


